import { NgFor, NgIf } from "@angular/common";
import { Component } from "@angular/core";
import { Button } from "@ankaadia/ankaadia-shared-frontend";
import { FormlyModule } from "@ngx-formly/core";
import { MessageModule } from "primeng-v17/message";
import { FormElementMapModule } from "../../shared/from-element-map/form-element-map.module";
import { NewUiFormlyRepeatComponent } from "./new-ui-formly-repeat.component";
import { TranslateDirective } from "../../shared/transloco/translate.directive";

@Component({
  selector: "app-formly-repeat",
  templateUrl: "./formly-repeat.component.html",
  imports: [FormElementMapModule, NgFor, MessageModule, FormlyModule, NgIf, Button, TranslateDirective],
})
export class FormlyRepeatComponent extends NewUiFormlyRepeatComponent {}
